import React, { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import { toast } from "react-toastify";
import TitleBar from "../../components/TitleBar";
import Divider from "@mui/material/Divider";
import "./GARFOVtr.scss";
import VtrList from "./GarfoVtrList";
import { mapVtrStateToProps } from "../../services/mapStateToProps";
import { vtrListRequest } from "../../actions/vtrList";
import {
  baseServerUrl,
  checkTokenValid,
  default_request,
  login_request,
  TIMEOUT_MESSAGE,
  AXIOS_ERROR,
} from "../../constants/default_request";
import moment from "moment";
import { Filter } from "./Filter";
import { isTestUser } from "../../reducers/rootReducer";
import {
  login,
  logout,
  vtrTripApiRequest,
} from "../../actions/middleware_actions";
import { Navigate } from "react-router-dom";
import Spinner from "../../components/common/Spinner";
import TokenRenewLogin from "../../components/TokenRenewLogin";
import ListTrips from "./GARFOList";
import { getOpenVtrTrips } from "../../actions/vtrTripStorage";
import { useViewport } from "../../components/CustomHooks/useViewport";
import Alert from "@mui/material/Alert";
import { BaseAPI } from "../../apis/BaseAPI";

const checkVtrListErrors = (currentState) => {
  return currentState.hasOwnProperty("error") &&
    Object.keys(currentState.error).length > 0
    ? true
    : false;
};

function VtrListPage({
  auth,
  listLoaded,
  loadVtrList,
  editTrip,
  userLogin,
  userLogout,
  ...props
}) {
  const isTokenValid = checkTokenValid(auth);
  const width = useViewport();
  const [tripId, setTripId] = useState(null);
  const [vesselPermit, setVesselPermit] = useState("");
  const [sailDate, setSailDate] = useState(null);
  const [filterSailDate, setFilterSailDate] = useState(null);
  const [password, setPassword] = useState("");
  const [validTokenNeeded, setValidTokenNeeded] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const [landDate, setLandDate] = useState(null);
  const [filterLandDate, setFilterLandDate] = useState(null);
  const [errorLoading, setErrorLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const currentVtrListState = useSelector((state) => state.vtrList);
  const didRequestFail = checkVtrListErrors(currentVtrListState);

  const pdfHandler = (input) => (event) => {
    const base_request_url = `${baseServerUrl}/base_api/pdfVtr`;
    let request_url = "";
    const tripId = event.currentTarget.dataset.tripId;
    if (isTestUser(auth.user_app_status)) {
      request_url = base_request_url.concat("/test");
    } else {
      request_url = base_request_url;
    }
    const request_data = default_request(
      auth.client_id,
      auth.token,
      auth.user_app_status
    );
    request_data.tripid = tripId;
    request_data.base64 = true;

    BaseAPI.getPdf(request_url, request_data)
      .then((response) => {
        let d = moment();
        let blob = new Blob([response.data], { type: "application/pdf" });
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        input === "save"
          ? (link.download =
              "vtr_" + tripId + "_" + d.format("YYYYMMDD_HHmmss") + ".pdf")
          : (link.target = "_blank");
        link.click();
      })
      .catch((error) => {
        console.log("garfoVTR_PDF:", error);
        if (error.hasOwnProperty("name") && error.name === AXIOS_ERROR) {
          toast.error(TIMEOUT_MESSAGE);
        } else {
          toast.error(`${error}`);
        }
      });
  };

  const editClick = (event) => {
    event.preventDefault();
    const allOpenTrips = getOpenVtrTrips(
      auth.client_id,
      event.currentTarget.dataset.tripId,
      true
    );
    if (allOpenTrips !== false) {
      toast.info(
        `Trip ${event.currentTarget.dataset.tripId} is currently being edited.`
      );
      return;
    }
    setShowSpinner(true);
    editTrip(
      auth.client_id,
      auth.token,
      auth.user_app_status,
      event.currentTarget.dataset.tripId
    );
  };

  const filterVesselChange = (event, reason) => {
    event.preventDefault();
    let permitNbr = null;
    if (reason) {
      console.log("Value Selected: ", reason);
      permitNbr = reason.PNUM;
    }
    setVesselPermit(permitNbr);
  };

  const filterDateChange = (input, date) => {
    let newDateTime = null;
    let bDateTime = null;
    if (date !== null) {
      newDateTime = moment(date, "YYMMDD");
      bDateTime = moment(newDateTime).format("YYMMDD");
    }
    if (input === "landDate") {
      setLandDate(newDateTime);
      setFilterLandDate(bDateTime);
    } else {
      setSailDate(newDateTime);
      setFilterSailDate(bDateTime);
    }
  };

  const handlePassword = (event, value) => {
    setPassword(value);
  };

  const submitForm = (event, username, password) => {
    event.preventDefault();
    const payload = login_request(username, password);
    userLogin(payload, username, password);
    setPassword("");
  };

  const handleTripChange = (event) => {
    event.preventDefault();
    setTripId(event.target.value);
  };

  const clearFilters = () => {
    window.location.reload();
  };

  useEffect(() => {
    if (didRequestFail) {
      setErrorLoading(true);
      setErrors(currentVtrListState.error);
    } else {
      setErrorLoading(false);
      setErrors({});
    }
  }, [didRequestFail, currentVtrListState]);

  useEffect(() => {
    if (!isTokenValid) {
      setValidTokenNeeded(true);
      setShowSpinner(false);
      return;
    } else {
      setValidTokenNeeded(false);
      setShowSpinner(false);
    }
    loadVtrList(auth.client_id, auth.token, auth.user_app_status);
  }, [
    isTokenValid,
    loadVtrList,
    auth.user_app_status,
    auth.token,
    auth.client_id,
  ]);

  let trips = props.trips.slice();

  if (tripId) {
    trips = trips.filter((trip) => {
      return trip.SUBMISSION_TYPE.toUpperCase() === "PAPER"
        ? trip.LOWEST_SERIAL_NUM === Number(tripId)
        : trip.TRIP_ID === tripId;
    });
  }
  if (vesselPermit && trips.length > 0) {
    trips = trips.filter((trip) =>
      trip.VESSEL_PERMIT_NUM.includes(vesselPermit)
    );
  }
  if (filterSailDate && trips.length > 0) {
    trips = trips.filter((trip) => trip.DATE_SAIL.includes(filterSailDate));
  }
  if (filterLandDate && trips.length > 0) {
    trips = trips.filter((trip) => trip.DATE_LAND.includes(filterLandDate));
  }

  return (
    <div style={{ marginTop: "20px" }}>
      <TitleBar title="GARFO VTR's" />
      <Divider />
      {props.vtrTrip.editRedirect && listLoaded && (
        <Navigate
          replace
          to={`${process.env.PUBLIC_URL}/vtr-trip-review`}
          state={{
            trip_id: props.vtrTrip.trip_id,
            client_id: auth.client_id,
            redirect: false,
          }}
        />
      )}
      <Divider />
      <Filter
        tripId={tripId}
        vesselPermit={vesselPermit}
        sailDate={sailDate}
        landDate={landDate}
        handleTripChange={handleTripChange}
        handleDateChange={filterDateChange}
        handleVesselChange={filterVesselChange}
        handleFilterClear={clearFilters}
        preferences={props.validations.validations.permit}
      />
      <Divider />
      {validTokenNeeded && (
        <TokenRenewLogin
          submitForm={submitForm}
          password={password}
          setPassword={handlePassword}
          logout={userLogout}
        />
      )}
      {Object.keys(errors).length > 0 && (
        <Alert severity="error">
          {errors.hasOwnProperty("message")
            ? errors.message
            : errors.hasOwnProperty("MESSAGE")
            ? errors.MESSAGE
            : errors.ERRORS}
        </Alert>
      )}
      <Divider />
      {(() => {
        if (
          (trips.length === 0 && listLoaded === true) ||
          Object.keys(errors).length > 0 ||
          errorLoading
        ) {
          return <p>No Trips Data available!</p>;
        } else if (
          (listLoaded === false || showSpinner) &&
          props.error.error.length === 0
        ) {
          return <Spinner />;
        } else if (trips.length > 0 && width < 620) {
          return (
            <VtrList
              vtrs={trips}
              editClick={editClick}
              pdfHandler={pdfHandler}
            />
          );
        } else {
          return (
            <ListTrips
              vtrs={trips}
              editClick={editClick}
              pdfHandler={pdfHandler}
              auth={auth}
            />
          );
        }
      })()}
    </div>
  );
}

const mapDispatchToProps = {
  loadVtrList: vtrListRequest,
  editTrip: vtrTripApiRequest,
  userLogout: logout,
  userLogin: login,
};

export default connect(mapVtrStateToProps, mapDispatchToProps)(VtrListPage);
